import { render, staticRenderFns } from "./ServicesFive.vue?vue&type=template&id=6206a567&"
import script from "./ServicesFive.vue?vue&type=script&lang=js&"
export * from "./ServicesFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports